import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorHandlerService } from '@aveva/connect-web-core';
import { Account } from 'src/app/models/account.model';
import { AccountsService } from 'src/app/services/accounts.service';
import * as globals from '../../globals';
import { LoggingService } from '../../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-add-account',
  templateUrl: './add-account.component.html',
  styleUrls: ['./add-account.component.scss']
})
export class AddAccountComponent {

  constructor(
    private errorHandler: ErrorHandlerService,
    private accountsService: AccountsService,
    private snackBar: MatSnackBar,
    private logger: LoggingService) { }

  create() {
    this.logger.logEvent('Add/Update Account initialised');
    this.loadingSpinner.emit(true);
    
    if (this.submitting) {
      return;
    }

    this.submitting = true;

    const accountData = (this.account.id !== undefined) ? 
    this.account : 
    { id: 0, account_id: this.account.account_id, account_name: this.account.account_name};

    try {
      this.accountsService.addOrUpdate(accountData).subscribe({
        next: (data) => {
          this.logger.logEvent('Add/Update Account Success.');
          this.form.resetForm();
          this.loadingSpinner.emit(false);
          this.saved.emit(data);
          this.displaySnackBar(this.account?.id === undefined ? globals.accountAdd_success : globals.accountUpdate_success);
        },
        error: (e) => {
          this.logger.logException(e);
          this.loadingSpinner.emit(false);
          this.displaySnackBar(this.account?.id === undefined ? globals.accountAdd_fail : globals.accountUpdate_fail);
        }
      });

    } catch (error) {
      this.logger.logException(error);
      if (error.status === 409) {
        this.form.controls['name'].setErrors({ 'notUnique': true });
      } else if (error.error?.statusCode === 400 && error.error?.errorCode === globals.RESOURCELIMIT) {
        this.errorHandler.handle(error.error, 'accountLimitReached');
      } else {
        return this.errorHandler.handle(error);
      }
    }
    finally {
      this.submitting = false;
    }
  }  

  cancel = () => this.cancelled.emit();

  close = () => this.cancelled.emit();
  
  displaySnackBar = (message: string) => this.snackBar.open(message, null, {duration: 3000});

  submitting = false;

  @Input() account: Account = new Account();
  @Output() saved: EventEmitter<any> = new EventEmitter();
  @Output() cancelled: EventEmitter<any> = new EventEmitter();
  @Output() loadingSpinner: EventEmitter<boolean> = new EventEmitter();
  @ViewChild('form', { static: true }) form: NgForm;

  @HostListener('window:beforeunload')
  canDeactivate = (): boolean => !this.form.dirty || this.form.submitted;
}
